exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer{margin-left:180px}.footer figure.image.earthlink{width:112px;margin-left:1em;margin-right:1em}@media screen and (max-width:1023px){.footer{margin-left:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21f9b32e","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/core/structure/AppFooter.vue
// module id = mGX+
// module chunks = 66